module.exports = __webpack_public_path__ + "static/engineering-3bc53298d05d9875fb67c2e843893207.png";